function SelectOptionsToPermissions(permissions) {
	var selectedOptions = permissions.map(function (o) {			
		return {id: parseInt(o.value), name: o.label}
	});		
	return selectedOptions;    
}
export default SelectOptionsToPermissions;